"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfListingMediaDto = instanceOfListingMediaDto;
exports.ListingMediaDtoFromJSON = ListingMediaDtoFromJSON;
exports.ListingMediaDtoFromJSONTyped = ListingMediaDtoFromJSONTyped;
exports.ListingMediaDtoToJSON = ListingMediaDtoToJSON;
exports.ListingMediaDtoToJSONTyped = ListingMediaDtoToJSONTyped;
var MediaMetadata_1 = require("./MediaMetadata");
/**
 * Check if a given object implements the ListingMediaDto interface.
 */
function instanceOfListingMediaDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('mediaMetadata' in value) || value['mediaMetadata'] === undefined)
        return false;
    return true;
}
function ListingMediaDtoFromJSON(json) {
    return ListingMediaDtoFromJSONTyped(json, false);
}
function ListingMediaDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'mediaMetadata': (0, MediaMetadata_1.MediaMetadataFromJSON)(json['mediaMetadata']),
    };
}
function ListingMediaDtoToJSON(json) {
    return ListingMediaDtoToJSONTyped(json, false);
}
function ListingMediaDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'mediaMetadata': (0, MediaMetadata_1.MediaMetadataToJSON)(value['mediaMetadata']),
    };
}
